module.exports = __webpack_public_path__ + "img/phone_hand_mobile.6db563fd.png";